/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Image } from './Image'
import { ImageFromJSON, ImageFromJSONTyped, ImageToJSON } from './Image'

/**
 *
 * @export
 * @interface MediaBlockData
 */
export interface MediaBlockData {
  /**
   *
   * @type {string}
   * @memberof MediaBlockData
   */
  imageSource?: string
  /**
   *
   * @type {Array<Image>}
   * @memberof MediaBlockData
   */
  conversions: Array<Image>
}

/**
 * Check if a given object implements the MediaBlockData interface.
 */
export function instanceOfMediaBlockData(
  value: object
): value is MediaBlockData {
  if (!('conversions' in value) || value['conversions'] === undefined)
    return false
  return true
}

export function MediaBlockDataFromJSON(json: any): MediaBlockData {
  return MediaBlockDataFromJSONTyped(json, false)
}

export function MediaBlockDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MediaBlockData {
  if (json == null) {
    return json
  }
  return {
    imageSource: json['imageSource'] == null ? undefined : json['imageSource'],
    conversions: (json['conversions'] as Array<any>).map(ImageFromJSON),
  }
}

export function MediaBlockDataToJSON(value?: MediaBlockData | null): any {
  if (value == null) {
    return value
  }
  return {
    imageSource: value['imageSource'],
    conversions: (value['conversions'] as Array<any>).map(ImageToJSON),
  }
}
